<div class="d-flex flex-column flex-lg-row gap-4 gap-lg-3 justify-content-end content-page content-solutions-list py-5">
  <div class="d-inline d-lg-none">
    <span class="fs-6 fw-semibold text-blue">Otras soluciones Kaizen</span>
  </div>
  <ng-container *ngFor="let item of solutions">
    <div class="d-flex flex-row flex-lg-column gap-2 gap-lg-3" *ngIf="item.id !== currentId">
      <img [src]="item.image" alt="image" width="398" height="398" class="img-solution">
      <div class="d-flex flex-column flex-lg-row gap-2 align-items-lg-center align-items-start justify-content-end justify-content-lg-start">
        <img [src]="item.icon" alt="logo" width="24" class="logo-solution">
        <span class="fs-6 text-blue title-solution">{{ item.title }}</span>
        <div class="content-show pointer" (click)="selectSolution(item)">
          <span class="fs-7">Ver</span>
        </div>
      </div>
    </div>
  </ng-container>
</div>